function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "64",
  height: "64",
  viewBox: "0 0 16.933 16.933",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.647 8.237L5.34 4.075a1.038 1.038 0 00-.913 0 .896.896 0 00-.457.776v8.324c0 .33.192.635.457.776a.829.829 0 00.456.118.824.824 0 00.457-.118l7.284-4.162a.896.896 0 00.457-.776c0-.33-.168-.635-.433-.776z",
  fill: "#200f41"
})));